var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComponentsWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "component"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LINE_295_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M17.1897 13.6818C16.3738 13.6818 15.6288 13.1344 15.4097 12.3073L13.1812 3.86027C12.9215 2.87443 13.5072 1.86366 14.4907 1.60335C15.476 1.3412 16.4816 1.93012 16.7422 2.91596L18.9707 11.363C19.2303 12.3489 18.6447 13.3597 17.6612 13.62C17.5037 13.6615 17.3453 13.6818 17.1897 13.6818Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_294_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M11.8065 19.0794C11.6509 19.0794 11.4925 19.0601 11.3341 19.0176L2.9082 16.7828C1.92564 16.5216 1.33905 15.5118 1.59873 14.5259C1.85841 13.541 2.86215 12.9493 3.85024 13.2133L12.2761 15.4481C13.2587 15.7093 13.8453 16.7191 13.5856 17.705C13.3683 18.533 12.6224 19.0794 11.8065 19.0794Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_293_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M44.5062 34.848C44.3506 34.848 44.1922 34.8286 44.0338 34.7862L35.6079 32.5514C34.6253 32.2902 34.0388 31.2803 34.2984 30.2945C34.5581 29.3095 35.5609 28.7178 36.5499 28.9818L44.9758 31.2166C45.9584 31.4778 46.545 32.4877 46.2853 33.4735C46.0671 34.3015 45.3221 34.848 44.5062 34.848Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_292_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M32.9199 46.4595C32.104 46.4595 31.3591 45.9121 31.1399 45.0851L28.9114 36.6389C28.6517 35.6531 29.2374 34.6423 30.2209 34.382C31.2071 34.1189 32.2118 34.7088 32.4724 35.6946L34.7009 44.1408C34.9606 45.1266 34.3749 46.1374 33.3914 46.3977C33.2339 46.4392 33.0756 46.4595 32.9199 46.4595Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_291_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M34.3602 27.1518C33.8887 27.1518 33.4181 26.9718 33.0581 26.6109C32.3389 25.89 32.3389 24.7214 33.0581 23.9995L44.742 12.2894C45.4612 11.5694 46.627 11.5684 47.3462 12.2894C48.0654 13.0103 48.0654 14.1789 47.3462 14.9008L35.6623 26.6118C35.3022 26.9718 34.8307 27.1518 34.3602 27.1518Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_290_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M46.0431 15.4419C45.5717 15.4419 45.1011 15.2619 44.741 14.901L33.0194 3.15115C32.3002 2.43023 32.3002 1.26162 33.0194 0.540692C33.7386 -0.180231 34.9044 -0.180231 35.6236 0.540692L47.3452 12.2905C48.0644 13.0115 48.0644 14.1801 47.3452 14.901C46.9852 15.261 46.5146 15.4419 46.0431 15.4419Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_289_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M22.6404 15.4032C22.169 15.4032 21.6984 15.2232 21.3383 14.8622C20.6192 14.1413 20.6192 12.9727 21.3383 12.2518L33.0195 0.540692C33.7387 -0.180231 34.9045 -0.180231 35.6237 0.540692C36.3429 1.26162 36.3429 2.43023 35.6237 3.15115L23.9425 14.8622C23.5825 15.2222 23.1119 15.4032 22.6404 15.4032Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_288_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M13.5615 47.9998C13.09 47.9998 12.6194 47.8198 12.2594 47.4589C11.5402 46.738 11.5402 45.5694 12.2594 44.8484L23.9424 33.1374C24.6616 32.4164 25.8274 32.4164 26.5466 33.1374C27.2658 33.8583 27.2658 35.0269 26.5466 35.7478L14.8636 47.4589C14.5035 47.8198 14.032 47.9998 13.5615 47.9998Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_287_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M13.5616 47.9996C13.0901 47.9996 12.6195 47.8196 12.2595 47.4587L0.53964 35.7107C-0.179554 34.9898 -0.179554 33.8212 0.53964 33.1003C1.25883 32.3793 2.42465 32.3793 3.14384 33.1003L14.8637 44.8492C15.5829 45.5701 15.5829 46.7387 14.8637 47.4596C14.5036 47.8196 14.0321 47.9996 13.5616 47.9996Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_286_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M1.84174 36.2518C1.37026 36.2518 0.899697 36.0718 0.53964 35.7109C-0.179554 34.9899 -0.179554 33.8213 0.53964 33.1004L12.2217 21.3893C12.9409 20.6684 14.1067 20.6684 14.8259 21.3893C15.5451 22.1102 15.5451 23.2789 14.8259 23.9998L3.14384 35.7118C2.78378 36.0718 2.31322 36.2518 1.84174 36.2518Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponentsWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/componentsWhite.05940e529f2b0678bdac9f8a9da2bd61.svg";